"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLabelDialogState = exports.useLabelDialogDetails = exports.LabelDialogDetailsContext = exports.useLabelDialogControlsDispatcher = exports.LabelDialogDispatcherContext = exports.useLabelDialogControlsState = exports.LabelDialogStateContext = exports.useLabelDialogReducer = void 0;
const tslib_1 = require("tslib");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
function reducer(state, action) {
    const last = state.kind === 'filter' ? state : state.last;
    switch (action.type) {
        case 'SELECT_ALL_LABELS':
            return { last, kind: 'all' };
        case 'SELECT_APPLIED_LABELS':
            return { last, kind: 'applied' };
        case 'RESET_FILTER':
            return state.kind === 'filter' ? Object.assign(Object.assign({}, state.last), { last: state }) : { kind: 'all' };
        case 'SELECT_CATEGORY':
            return { kind: 'category', category: action.category };
        case 'SELECT_VALUE':
            return Object.assign(Object.assign({}, state), { value: action.value });
        case 'SEARCH_VALUE':
            return state.kind === 'filter'
                ? Object.assign(Object.assign({}, state), { filter: action.filter, value: undefined }) : { kind: 'filter', last: state, filter: action.filter, value: undefined };
    }
}
function useLabelDialogReducer(initial) {
    return react_1.default.useReducer(reducer, initial);
}
exports.useLabelDialogReducer = useLabelDialogReducer;
exports.LabelDialogStateContext = react_1.default.createContext({ kind: 'all' });
function useLabelDialogControlsState() {
    return react_1.default.useContext(exports.LabelDialogStateContext);
}
exports.useLabelDialogControlsState = useLabelDialogControlsState;
exports.LabelDialogDispatcherContext = react_1.default.createContext((_) => {
    return;
});
function useLabelDialogControlsDispatcher() {
    return react_1.default.useContext(exports.LabelDialogDispatcherContext);
}
exports.useLabelDialogControlsDispatcher = useLabelDialogControlsDispatcher;
exports.LabelDialogDetailsContext = react_1.default.createContext({ categories: {}, values: {} });
function useLabelDialogDetails() {
    return react_1.default.useContext(exports.LabelDialogDetailsContext);
}
exports.useLabelDialogDetails = useLabelDialogDetails;
function useLabelDialogState() {
    return (0, formik_1.useFormikContext)();
}
exports.useLabelDialogState = useLabelDialogState;
//# sourceMappingURL=LabelsDialogContexts.js.map